import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { WeCallYouComponent } from '@app/@shared/components/we-call-you/we-call-you.component';

@Component({
  selector: 'app-investment-calculator',
  templateUrl: './investment-calculator.component.html',
  styleUrls: ['./investment-calculator.component.scss'],
})
export class InvestmentCalculatorComponent {
  readonly minIncome = 200;
  readonly maxIncome = 2000;
  readonly returnRate = 0.06;

  monthlyIncome = 500;

  constructor(public dialog: MatDialog) {}

  get annualIncome(): number {
    return this.monthlyIncome * 12;
  }

  get investmentNeeded(): number {
    return Math.ceil(this.annualIncome / this.returnRate / 1000) * 1000;
  }

  get sliderPercent(): string {
    const pct = ((this.monthlyIncome - this.minIncome) / (this.maxIncome - this.minIncome)) * 100;
    return pct + '%';
  }

  onSliderChange(event: Event): void {
    this.monthlyIncome = +(event.target as HTMLInputElement).value;
  }

  formatAmount(value: number): string {
    return new Intl.NumberFormat('es-ES').format(value);
  }

  openCallModal(): void {
    this.dialog.open(WeCallYouComponent, {
      maxWidth: '95vw',
      panelClass: 'noPadding',
      data: {
        monthlyIncome: this.monthlyIncome,
        investmentNeeded: this.investmentNeeded,
      },
    });
  }
}
